var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量加好友导入",
        visible: _vm.dialogVisiImport,
        width: "50%",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisiImport = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.diaLoading,
              expression: "diaLoading"
            }
          ],
          staticClass: "container_row"
        },
        [
          _c("span", [_vm._v("请选择文件：")]),
          _c(
            "el-upload",
            {
              ref: "uploadRef",
              staticClass: "upload-demo",
              attrs: {
                action: _vm.sendUrl,
                headers: _vm.headers,
                multiple: false,
                "auto-upload": false,
                "before-upload": _vm.beforeUpload,
                "on-error": _vm.onError,
                "on-success": _vm.handleSuccess,
                accept: ".xls,.xlsx,.csv",
                "on-remove": _vm.onRemove,
                "on-change": _vm.handleChange,
                "file-list": _vm.fileList
              }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("请选择 Excel 文件")
              ]),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(_vm.text))
              ]),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v(" 只能上传.xls/.xlsx/.csv格式文件，且不超过20M ")]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  return _vm.downLoadTemplate()
                }
              }
            },
            [_vm._v("下载导入模板")]
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.submit }
            },
            [_vm._v("导入")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }